import { Spinner } from '@wyz/ui';
import { useManageCustomers } from '~/common/api';
import { PAGINATE_ALL_LIMIT } from '~/common/helpers';
import { ENTITIES_STATUSES } from '~/common/schemas';
import { IFeatureContext } from '~/common/types';

type Props = {
  criteria: Array<{ id: string; value: string }>;
  featureContext: IFeatureContext;
  matchUserContext?: boolean;
  parentIds?: Array<string>;
  limit?: number;
};

const MatchedCustomersCount = ({
  criteria,
  featureContext,
  matchUserContext = false,
  parentIds,
  limit = PAGINATE_ALL_LIMIT,
}: Props) => {
  const valuesByCriterionId = criteria.reduce(
    (acc, criterion) => {
      if (!acc[criterion.id]) {
        acc[criterion.id] = [];
      }
      acc[criterion.id].push(criterion.value);
      return acc;
    },
    {} as Record<string, Array<string>>,
  );

  const manageCustomers = useManageCustomers({
    paginateMatched: {
      args: {
        page: 1,
        limit,
        statuses: [ENTITIES_STATUSES.ENABLED],
        criteria: Object.keys(valuesByCriterionId).map((criterionId) => ({
          criterion: criterionId,
          values: valuesByCriterionId[criterionId],
        })),
        featureContext,
        matchUserContext,
        parentIds,
      },
    },
  });

  return (
    <span>
      {manageCustomers.paginateMatched.isFetching ? (
        <Spinner style={{ width: 10, height: 10 }} />
      ) : (
        manageCustomers.paginateMatched.data?.meta.total
      )}
    </span>
  );
};

export default MatchedCustomersCount;
